import React from 'react';
import TablePage from './TablePage';
import { connect } from 'react-redux';
import data from './dummy';
import { InputGroup, Input, Button, InputGroupAddon } from 'reactstrap';

class Table extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowIndex: null,
      isEditting: false,
      edittingValue: null,
    };
    this.columns = [
      { Header: 'ID', accessor: 'id' },
      { Header: 'Full Name', accessor: 'fullName' },
      { Header: 'Email', accessor: 'email' },
      { Header: 'Phone', accessor: 'phone', Cell: this.formatPhone },
    ];
  }
  formatPhone = (props) => {
    const rowIndex = props.row.index;
    const { isEditting } = this.state;
    if (isEditting && rowIndex === this.state.rowIndex) {
      return (
        <InputGroup>
          <Input />
          <InputGroupAddon addonType="append">
            <button>Override</button>
            <button>Normal</button>
          </InputGroupAddon>
        </InputGroup>
      );
    }
    return (
      <div
        className="d-flex justify-content-between align-items-center"
        onMouseEnter={() => this.setRowIndex(rowIndex)}
        onMouseLeave={() => this.setRowIndex(null)}
      >
        {props.value}
        {this.state.rowIndex === rowIndex && (
          <a
            style={{ cursor: 'pointer', display: 'flex' }}
            onClick={() => this.toggleEditCell(props.value)}
          >
            <i className="md-icon">edit</i>
          </a>
        )}
      </div>
    );
  };
  setRowIndex = (rowIndex) => {
    if (!this.state.isEditting) {
      this.setState({ rowIndex });
    }
  };
  toggleEditCell = (value) => {
    const isEditting = !this.state.isEditting;
    if (isEditting) {
      this.setState({ isEditting, edittingValue: value });
    } else {
      this.setState({ isEditting, edittingValue: null });
    }
  };
  render() {
    return <TablePage columns={this.columns} data={data} />;
  }
}

export default connect(null, null)(Table);
